import { render } from "./LoadingLessonPage.vue?vue&type=template&id=15266503"
import script from "./LoadingLessonPage.vue?vue&type=script&lang=js"
export * from "./LoadingLessonPage.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__